<template>
  <div class="authorize-user-management">
    <!-- 查询区域 -->
    <a-card :bordered="false" class="card-area">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="16">
            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="用户账号" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    placeholder="请输入用户账号"
                    v-model="queryState.userAccount"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="联系电话" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    placeholder="请输入联系电话"
                    v-model="queryState.telephone"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="邮箱" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    placeholder="请输入邮箱"
                    v-model="queryState.email"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="12" :xs="24">
              <a-form-item label="代理商名称" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                <a-input
                    placeholder="请输入代理商名称"
                    v-model="queryState.agentName"
                    style="width: 100%"/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="12" :xs="24">
              <a-form-item label="创建时间" :labelCol="{span: 6}" :wrapperCol="{span: 18}">
                <a-range-picker
                    v-model="createTimeRange"
                    style="width: 100%"
                    :show-time="{
                      format: 'HH:mm',
                      defaultValue: [this.moment('00:00:00', 'HH:mm:ss'), this.moment('23:59:59', 'HH:mm:ss')]
                    }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['开始时间', '结束时间']"
                    @change="handleCreateTimeChange"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin-top: 5px; display: flex; justify-content: space-between; align-items: center;">
        <div style="flex: 1;">
          <a-button type="primary" @click="handleAdd" style="margin-right: 8px;">
            新增
          </a-button>
        </div>

        <div style="flex: 1; text-align: right;">
          <a-button type="primary" icon="search" @click="handleSearch" style="margin-right: 8px;">
            查询
          </a-button>
          <a-button icon="reload" @click="handleReset" style="margin-right: 8px;">
            重置
          </a-button>
        </div>
      </div>
    </a-card>

    <!-- 表格区域 -->
    <a-card title="授权客户列表" :bordered="false" class="table-card">
      <a-table
          :columns="columns"
          :data-source="tableData"
          :pagination="pagination"
          :loading="loading"
          row-key="id"
          bordered
          size="middle"
          @change="handleTableChange"
      >
        <template slot="status" slot-scope="text, record">
          <a-switch
              :checked="record.status === 1"
              @change="(checked) => handleStatusChange(record, checked)"
              checked-children="启用"
              un-checked-children="禁用"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm
              title="确定要删除这条记录吗？"
              @confirm="handleDelete(record)"
              ok-text="确定"
              cancel-text="取消"
          >
            <a style="color: #ec0941">删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </a-card>

    <!-- 新增/编辑对话框 -->
    <a-modal
        v-model="modalVisible"
        :title="modalTitle"
        width="600px"
        centered
        @ok="handleSubmit"
        @cancel="handleCancel"
        :confirm-loading="submitLoading"
    >
      <a-form
          :form="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
      >
        <a-form-item label="用户账号">
          <a-input
              v-decorator="[
                'userAccount',
                {
                  rules: [{ required: true, message: '请输入用户账号' }]
                }
              ]"
              placeholder="请输入用户账号"
              :disabled="isEdit"
          />
        </a-form-item>

        <a-form-item label="联系电话">
          <a-input
              v-decorator="[
                'telephone',
                {
                  rules: [{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码' }]
                }
              ]"
              placeholder="请输入联系电话"
          />
        </a-form-item>

        <a-form-item label="邮箱">
          <a-input
              v-decorator="[
                'email',
                {
                  rules: [{ type: 'email', message: '请输入正确的邮箱地址' }]
                }
              ]"
              placeholder="请输入邮箱"
          />
        </a-form-item>

        <a-form-item label="代理商名称">
          <a-input
              v-decorator="['agentName']"
              placeholder="请输入代理商名称"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import { getAuthorizeUserList, addAuthorizeUser, updateAuthorizeUser, deleteAuthorizeUser, updateAuthorizeUserStatus } from 'api/customer';
import moment from 'moment';

export default {
  name: 'AuthorizeUser',
  data() {
    return {
      // 查询状态
      queryState: {
        userAccount: '',
        telephone: '',
        email: '',
        agentName: '',
        startTime: '',
        endTime: ''
      },
      createTimeRange: [],

      // 表格状态
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50'],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      // 模态框状态
      modalVisible: false,
      modalTitle: '新增授权客户',
      isEdit: false,
      currentRecord: {},
      submitLoading: false,
      form: this.$form.createForm(this),



      // 表格列配置
      columns: [
        {
          title: '用户账号',
          dataIndex: 'userAccount',
          key: 'userAccount',
          align: "center",
          width: 150
        },
        {
          title: '联系电话',
          dataIndex: 'telephone',
          key: 'telephone',
          align: "center",
          width: 140
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          key: 'email',
          align: "center",
          width: 180
        },
        {
          title: '代理商名称',
          dataIndex: 'agentName',
          key: 'agentName',
          align: "center"
        },
        {
          title: '授权码',
          dataIndex: 'authCode',
          key: 'authCode',
          align: "center"
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'status'},
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          align: "center",
          width: 160,
          customRender: (text) => {
            return text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : '-';
          }
        },
        {
          title: '操作',
          key: 'action',
          align: "center",
          width: 120,
          fixed: 'right',
          scopedSlots: {customRender: 'action'},
        }
      ]
    };
  },

  mounted() {
    this.loadTableData();
  },

  methods: {
    // 提供moment方法给模板使用
    moment,

    // 创建时间范围变化
    handleCreateTimeChange(dates) {
      this.createTimeRange = dates;
      this.queryState.startTime = dates && dates[0] ? dates[0] : '';
      this.queryState.endTime = dates && dates[1] ? dates[1] : '';
    },

    // 加载表格数据
    async loadTableData() {
      this.loading = true;
      try {
        const params = {
          ...this.queryState,
          startTime: this.queryState.startTime ? moment(this.queryState.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
          endTime: this.queryState.endTime ? moment(this.queryState.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
          current: this.pagination.current,
          size: this.pagination.pageSize
        };
        const res = await getAuthorizeUserList(params);
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.error(res.message || '加载授权客户数据失败');
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (error) {
        console.error('加载授权客户数据失败:', error);
        message.error('加载授权客户数据失败');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 查询
    handleSearch() {
      this.pagination.current = 1;
      this.loadTableData();
    },

    // 重置
    handleReset() {
      this.queryState = {
        userAccount: '',
        telephone: '',
        email: '',
        agentName: '',
        startTime: '',
        endTime: ''
      };
      this.createTimeRange = [];
      this.pagination.current = 1;
      this.loadTableData();
    },

    // 表格变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.loadTableData();
    },

    // 新增
    handleAdd() {
      this.modalVisible = true;
      this.modalTitle = '新增授权客户';
      this.isEdit = false;
      this.currentRecord = {};
      this.$nextTick(() => {
        this.form.resetFields();
      });
    },

    // 编辑
    handleEdit(record) {
      this.modalVisible = true;
      this.modalTitle = '编辑授权客户';
      this.isEdit = true;
      this.currentRecord = { ...record };
      this.$nextTick(() => {
        this.form.setFieldsValue({
          userAccount: record.userAccount,
          telephone: record.telephone,
          email: record.email,
          agentName: record.agentName
        });
      });
    },

    // 删除
    async handleDelete(record) {
      try {
        const res = await deleteAuthorizeUser(record.id);
        if (res.code === 200) {
          message.success('删除成功');
          this.loadTableData();
        } else {
          message.error(res.message || '删除失败');
        }
      } catch (error) {
        console.error('删除失败:', error);
        message.error('删除失败');
      }
    },

    // 提交
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitLoading = true;
          try {
            const params = {
              ...values
            };

            let res;
            if (this.isEdit) {
              params.id = this.currentRecord.id;
              res = await updateAuthorizeUser(params);
            } else {
              res = await addAuthorizeUser(params);
            }

            if (res.code === 200) {
              message.success(this.isEdit ? '编辑成功' : '新增成功');
              this.modalVisible = false;
              this.loadTableData();
            } else {
              message.error(res.message || '提交失败');
            }
          } catch (error) {
            console.error('提交失败:', error);
            message.error('提交失败');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    },

    // 状态变更
    async handleStatusChange(record, checked) {
      try {
        const status = checked ? 1 : 0;
        const res = await updateAuthorizeUserStatus({
          id: record.id,
          status: status
        });

        if (res.code === 200) {
          message.success(checked ? '启用成功' : '禁用成功');
          // 更新本地数据
          const index = this.tableData.findIndex(item => item.id === record.id);
          if (index !== -1) {
            this.tableData[index].status = status;
          }
        } else {
          message.error(res.message || '状态更新失败');
          // 恢复开关状态
          this.$forceUpdate();
        }
      } catch (error) {
        console.error('状态更新失败:', error);
        message.error('状态更新失败');
        // 恢复开关状态
        this.$forceUpdate();
      }
    },

    // 取消
    handleCancel() {
      this.modalVisible = false;
      this.form.resetFields();
    }
  }
};
</script>

<style scoped>
.authorize-user-management {
  padding: 16px;
}

.card-area {
  margin-bottom: 16px;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-card {
  background: #fff;
}
</style>
